
import { getToken, setUser } from "../utils/comman/Common"
import axiosinstances from "../Helper/useAxios";

 export async function getbalanceresponse(id) {
    const [axiosInstance] = axiosinstances() 
//console.log('idid',id)
    const d=sessionStorage.getItem('token') && JSON.parse(sessionStorage.getItem('token')).token ? JSON.parse(sessionStorage.getItem('token')).token : "";
    const e=JSON.parse(sessionStorage.getItem('token'))
    return  axiosInstance
    .get(`/api/v1/account/balance/${id}`,{ headers: {"Authorization" : `Bearer ${e}`,"client-id":id,"role":"ROLE_RETAILER_FINXPAY"}})
    .then(response => {
        if (response) {
            const { data } = response
             
            return data
        }
        return false
    })
   .catch((err) => {
     //console.log(err);
   });
    // return axios.get(`http://qa.finxpay.co.in/api/v1/account/balance/${id}`,{ headers: {"Authorization" : `Bearer ${e}`,"client-id":id,"role":"ROLE_RETAILER_FINXPAY"}})
    // .then(response => {
    //         if (response) {
    //             const { data } = response
                 
    //             return data
    //         }
    //         return false
    //     })
}
